module.exports = __webpack_public_path__ + "static/media/fake_ean.82fd4b91.jpg";